import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { selectCurrentBenchmarkReportIconsMap } from 'spw-redux/modules/benchmark-reports/selectors';
import {
  BenchmarkReportCardType,
  BenchmarkReportIconType,
  BenchmarkReportUSFMetrics,
} from 'spw-redux/modules/benchmark-reports/types';
import { Row } from 'spw-shared/globalComponents';
import { colors } from 'spw-theme';
import styled from 'styled-components';

const Metrics = styled(Row)`
  align-items: center;

  img {
  }

  .value {
    color: ${colors.black};
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 8px;
  }

  .label {
    color: ${colors.fontColor};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
  }
`;

type Props = {
  metrics: BenchmarkReportUSFMetrics;
};

const cardType = BenchmarkReportCardType.usfMetrics;

function USFMetrics({ metrics }: Props) {
  const { getUnit, convertArea } = useUnitConversion();
  const currentReportIconsMap = useSelector(
    selectCurrentBenchmarkReportIconsMap
  );

  const getIcon = (iconType: BenchmarkReportIconType) =>
    `/images/space-icons/${currentReportIconsMap[cardType][iconType]}.svg`;

  return (
    <div data-cy="usf_metrics_card">
      <div className="title">{getUnit('area')} METRICS</div>
      <Row justifyContent="center">
        <Metrics>
          <img
            src={getIcon(BenchmarkReportIconType.workSeat)}
            alt="work seat"
            width={84}
          />
          <Box>
            <div className="value" data-testid="usf_per_workseat">
              {Math.round(convertArea(metrics?.usfPerWorkSeat) || 0)}
            </div>
            <div className="label">{getUnit('area')} / Work Seat</div>
          </Box>
        </Metrics>
        {metrics?.usfPerHeadcount ? (
          <Metrics ml="80px">
            <img
              src={getIcon(BenchmarkReportIconType.headcount)}
              alt="work seat"
              height={56}
            />
            <Box ml={2}>
              <div className="value" data-testid="usf_per_headcount">
                {Math.round(convertArea(metrics?.usfPerHeadcount))}
              </div>
              <div className="label">{getUnit('area')} / Headcount</div>
            </Box>
          </Metrics>
        ) : null}
      </Row>
    </div>
  );
}

export default USFMetrics;
